import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllAccounts = () =>
  apiClient.get(REST_API_BASE_URL + '/accounts');

export const getAllAppsByAccount = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${id}/apps`);

export const saveAccount = (account) =>
  apiClient.post(REST_API_BASE_URL + '/account', account);

export const getAccount = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${id}`);

export const updateAccount = (id, account) =>
  apiClient.put(`${REST_API_BASE_URL}/account/${id}`, account);

export const deleteAccount = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/account/${id}`);

export const addUserToAccount = (accid, userid) =>
  apiClient.post(`${REST_API_BASE_URL}/account/${accid}/user/${userid}`);

export default apiClient;
